import React, {useEffect, useState} from 'react'
import WhiteArrowRight from '../../../media/felsv/white_right-arrow_icon.svg'
import DarkArrowLeft from '../../../media/felsv/dark_left-arrow_icon.svg'
import {FormCreacionUsuario} from '../../../interfaces/creacionUsuario.interface'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {
  actionCreacionUsuario,
  actionValidatorsCreacionUsuario,
} from '../../../actions/action-creators'
import {bindActionCreators} from 'redux'
import InputIcon from '../../../components/Inputs/InputIcon'
import DarkMail from '../../../media/felsv/dark_message_icon.svg'
import SecondaryMail from '../../../media/felsv/secondary_message_icon.svg'
import DarkPhone from '../../../media/felsv/DarkPhone.svg'
import SecondaryPhone from '../../../media/felsv/SecondaryPhone.svg'
import DarkLocation from '../../../media/felsv/DarkLocation.svg'
import SecondaryLocation from '../../../media/felsv/SecondaryLocation.svg'
import {DICCIONARIO} from '../../../constants/Diccionario'
import {useHistory} from 'react-router-dom'
import InputPhone from '../../../components/Inputs/InputPhone'
import { KEYS } from '../../../constants/keysStorage'

const ContactoCC = (props: any) => {
  const [disable, setDisable] = useState(true)
  const usuario: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formUser)
  const errors: FormCreacionUsuario = useSelector((state: State) => state.creacionUsuario.formError)
  const history = useHistory()
  const dispatch = useDispatch()

  const creacion = bindActionCreators(actionCreacionUsuario, dispatch)
  const validaciones = bindActionCreators(actionValidatorsCreacionUsuario, dispatch)

  useEffect(() => {
    if (usuario.email && usuario.phone_number && !errors.email && !errors.phone_number && !errors.location)
      setDisable(false)
    else setDisable(true)
  }, [usuario, errors])

  const submit = async (e: any) => {
    e.preventDefault()
    if (await validaciones.validacionesCreacionUsuarioFormContactoSiguiente()) return
    if (await creacion.creacionUsuarioCreacion()) {
      localStorage.setItem(KEYS.FLAG_VERIFY_VIEW, 'true');
      history.push('/account-confirm');
    }
  }
  
  const handleInput = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    creacion.creacionUsuarioFormHandleChange(event)
    validaciones.validacionesCreacionUsuarioOnBlurContacto(event)
  }

  return (
    <form
      className='form-content'
      data-wf-page-id='64af1c9680a05070de3c97df'
      data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
      onSubmit={submit}
    >
      <div>
        <label htmlFor='email' className='field-label m'>
          {DICCIONARIO.EMAIL}
          <span style={{color: 'red'}}>*</span>
        </label>
        <div className='s alert-info-text' style={{maxWidth: 380, fontSize: 11}}>(verifica que tengas acceso al correo ingresado)</div>
        <InputIcon
          secondaryIcon={SecondaryMail}
          darkIcon={DarkMail}
          type='email'
          className='m text-field-icon email w-input'
          maxLength={50}
          name='email'
          data-name='email'
          placeholder={DICCIONARIO.EMAIL}
          id='email'
          autoFocus
          value={usuario.email}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurContacto}
        />
        {errors.email && <p className='alert s'>{errors.email}</p>}
      </div>
      <div>
        <label htmlFor='phone_number' className='field-label m'>
          {DICCIONARIO.TELEFONO}
          <span style={{color: 'red'}}>*</span>
        </label>
          <InputPhone
            disabled = {false}
            className='m text-field w-input'
            value={usuario.phone_number}
            onChange={creacion.creacionUsuarioFormHandleChangePhone}
            onBlur={validaciones.validacionesCreacionUsuarioOnBlurContacto}
            name='phone_number'
          />
        {/* <InputIcon
          secondaryIcon={SecondaryPhone}
          darkIcon={DarkPhone}
          type='tel'
          className='m text-field-icon phone w-input'
          maxLength={45}
          minLength={8}
          data-name='phone_number'
          placeholder={DICCIONARIO.TELEFONO}
          id='phone_number'
          value={usuario.phone_number}
          onChange={creacion.creacionUsuarioFormHandleChange}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurContacto}
        /> */}
        {errors.phone_number && <p className='alert s'>{errors.phone_number}</p>}
      </div>
      <div>
        <label htmlFor='location' className='field-label m'>
          Dirección
        </label>
        <InputIcon
          secondaryIcon={SecondaryLocation}
          darkIcon={DarkLocation}
          type='text'
          className='m text-field-icon location w-input'
          maxLength={100}
          name='location'
          data-name='location'
          placeholder='Dirección exacta'
          id='location'
          value={usuario.location}
          onChange={handleInput}
          onBlur={validaciones.validacionesCreacionUsuarioOnBlurContacto}
        />
        {errors.location && <p className='alert s'>{errors.location}</p>}
      </div>
      <div className='w-layout-hflex button-actions' style={{marginBottom: '5%'}}>
        <button type='button' className='m button transparent w-inline-block' onClick={props.prev}>
          <img src={DarkArrowLeft} loading='lazy' alt='Regresar' />
          Regresar
        </button>
        <button type='submit' className='m button w-inline-block' disabled={disable}>
          Siguiente
          <img src={WhiteArrowRight} loading='lazy' alt='Siguiente' />
        </button>
      </div>
    </form>
  )
}

export default ContactoCC
